import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-jalaali';

@Pipe({
  name: 'getRemainingDays'
})
export class GetRemainingDaysPipe implements PipeTransform {

  transform(value: any, args: any): any {
    const initial = moment(value);
    const target = moment(args);

    return target.diff(initial, 'minutes') * 60;
  }

}
